import React, { useEffect, useState } from "react";
import api from '../../../components/api'

import { onlyNumberWithTwoDecimal } from '../../../components/functions'
import InputMask from 'react-input-mask'

import { useEnergiaHvacIndiretaContext } from '../../../context/energiaHvacIndiretaContext'
import moment from 'moment'
import { useTabelaGestao } from '../../../context/GestaoPendenciasContext'

const Modal = (props) => {

    const energia_id = props.energia_id
    const adesao_institucional_id = props.adesao_institucional_id
    const ano = props.ano

    const { atualizacaoGestao, setAtualizacaoGestao } = useTabelaGestao()

    const { energiaHvacExpansaoIndireta_id, setEnergiaHvacExpansaoIndireta_id } = useEnergiaHvacIndiretaContext()


    const [marcaChiller, setMarcaChiller] = useState('')
    const [modeloChiller, setModeloChiller] = useState('')
    const [anoFabricacaoChiller, setAnoFabricacaoChiller] = useState('')
    const [quantidadeChiller, setQuantidadeChiller] = useState('')
    const [capacidadeTermicaChiller, setCapacidadeTermicaChiller] = useState('')
    const [potenciaEletricaChiller, setPotenciaEletricaChiller] = useState('')
    const [copChiller, setCopChiller] = useState('')
    const [fluidoRefrigeranteChiller, setFluidoRefrigeranteChiller] = useState('')
    const [tipoChiller, setTipoChiller] = useState('')
    const [condensacao, setCondensacao] = useState('')
    const [queima, setQueima] = useState('')
    const [cag, setCag] = useState('')
    const [rotinaManutencaoChiller, setRotinaManutencaoChiller] = useState('')
    const [funcionamentoHorasDiaChiller, setFuncionamentoHorasDiaChiller] = useState('')
    const [funcionamentoDiasSemanaChiller, setFuncionamentoDiasSemanaChiller] = useState('')
    const [funcionamentoSemanasAnoChiller, setFuncionamentoSemanasAnoChiller] = useState('')
    const [entradaOperacaoChiller, setEntradaOperacaoChiller] = useState('')
    const [saidaOperacaoChiller, setSaidaOperacaoChiller] = useState('')

    const [resultadoMarcaChiller, setResultadoMarcaChiller] = useState()
    const [resultadoFluidoRefrigerante, setResultadoFluidoRefrigerante] = useState()

    const [listaAnos, setListaAnos] = useState()

    function consultaFluidoRefrigerante() {

        api.get('fluidoRefrigeranteListaTodos').then((result) => {

            //console.log(result.data)

            setResultadoFluidoRefrigerante(result.data.map((rs) =>
            
                <option key={rs.fluidoRefrigerante_id} value={rs.descricao}>{rs.descricao}</option>
            
            ))


        }).catch((err) => {

            console.log(err.response)

        })

    }


    function avisoCopChiller() {

        
        if (potenciaEletricaChiller != '' && capacidadeTermicaChiller != '') {


            if (potenciaEletricaChiller != '0') {

                var copCalculo = parseFloat(capacidadeTermicaChiller.replaceAll(',', '.')) * 3.51685 / parseFloat(potenciaEletricaChiller.replaceAll(',', '.'))
                //console.log(copCalculo)

                setCopChiller(copCalculo.toFixed(2).toString().replaceAll('.', ','))
                window.toastr.info(`Conforme os valores fornecidos o COP deve ser aproximadamente <b>${copCalculo.toFixed(2).toString().replaceAll('.', ',')}</b>`)

                /*

                window.$.confirm({
                    //icon: 'fa fa-question',
                    theme: 'material',
                    closeIcon: true,
                    animation: 'scale',
                    type: 'orange',
                    title: 'Aviso',
                    content: `Conforme os valores fornecidos o COP deve ser aproximadamente <b>${copCalculo.toFixed(2).toString().replaceAll('.', ',')}</b>`,
                    buttons: {
                        Ok: function () {
        
                            
        
                        },
                        
        
                    },
        
                });

                */

            }



        }


    }

    function avisoQueima() {

        if (queima == 'Direta') {

            //console.log('!?')

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'orange',
                title: 'Aviso',
                content: 'Por favor, reportar o combustível usado na queima na aba <b>Combustíveis</b>!',
                buttons: {
                    Entendi: function () {
    
    
                    },
                    
    
                },
    
            });


        }

    }


    function carregaAnos() {

        

        var x_array = []

        for (var x = 1990; x <= 2030; x++) {
            
            x_array.push(x)

        }


        //console.log(x_array, 'aqui')
        setListaAnos(x_array.sort().reverse().map((ano) =>
        
            <option value={ano}>{ano}</option>
        
        ))
        

    }

    function carregaMarcaChiller() {


        api.get(`energiaHvacChillerListaTodos`).then((result) => {

            setResultadoMarcaChiller(result.data.map((rs) =>
            
                <option value={rs.descricao}>{rs.descricao}</option>
            
            ))

        }).catch((err) => {

            console.log(err.response)

        })

        

    }


    function carregaHvacDetIndireta() {

        
        if (energiaHvacExpansaoIndireta_id) {

            api.get(`energiaHvacExpansaoIndiretaListaUm/${energiaHvacExpansaoIndireta_id}`).then((result) => {


                var data = result.data[0]

                console.log(data)

                setMarcaChiller(data.marcaChiller)
                setModeloChiller(data.modeloChiller)
                setAnoFabricacaoChiller(data.anoFabricacaoChiller == null ? '' : data.anoFabricacaoChiller.toString())
                setQuantidadeChiller(data.quantidadeChiller == null ? '' : data.quantidadeChiller.toString())
                setCapacidadeTermicaChiller(data.capacidadeTermicaChiller == null ? '' : data.capacidadeTermicaChiller.toString())
                setPotenciaEletricaChiller(data.potenciaEletricaChiller == null ? '' : data.potenciaEletricaChiller.toString())
                setCopChiller(data.copChiller == null ? '' : data.copChiller.toString())
                setFluidoRefrigeranteChiller(data.fluidoRefrigeranteChiller)
                setTipoChiller(data.tipoChiller)
                setCondensacao(data.condensacao)
                setQueima(data.queima)
                setCag(data.cag)
                setRotinaManutencaoChiller(data.rotinaManutencaoChiller)
                setFuncionamentoHorasDiaChiller(data.funcionamentoHorasDiaChiller == null ? '' : data.funcionamentoHorasDiaChiller.toString())
                setFuncionamentoDiasSemanaChiller(data.funcionamentoDiasSemanaChiller == null ? '' : data.funcionamentoDiasSemanaChiller.toString())
                setFuncionamentoSemanasAnoChiller(data.funcionamentoSemanasAnoChiller == null ? '' : data.funcionamentoSemanasAnoChiller.toString())
                setEntradaOperacaoChiller(data.entradaOperacaoChiller)
                setSaidaOperacaoChiller(data.saidaOperacaoChiller)


            }).catch((err) => {

                console.log(err.response)

            })

        }


    }




    function salvaExpansaoIndireta() {


        if (marcaChiller == '') {

            window.toastr.error('<b>Marca do Chiller</b> não pode ficar em branco!')
            return false;

        }

        if (anoFabricacaoChiller == '') {

            window.toastr.error('<b>Ano do Chiller</b> não pode ficar em branco!')
            return false;

        }

        if (capacidadeTermicaChiller == '') {

            window.toastr.error('<b>Capacidade Térmica</b> não pode ficar em branco!')
            return false;

        } else {


            if (capacidadeTermicaChiller == '0') {

                window.toastr.error('<b>Capacidade Térmica</b> não pode ser igual a zero!')
                return false
    
            }

        }



        if (potenciaEletricaChiller == '') {

            window.toastr.error('<b>Potência Elétrica</b> não pode ficar em branco!')
            return false;

        } else {

            if (potenciaEletricaChiller == '0') {

                window.toastr.error('<b>Potência Elétrica</b> não pode ser igual a zero!')
                return false
    
            }

        }

        if (quantidadeChiller == '') {


            window.toastr.error('<b>Quantidade</b> não pode ficar em branco!')
            return false;


        } else {

            if (quantidadeChiller == '0') {

                window.toastr.error('<b>Quantidade</b> não pode ser igual a zero!')
                return false
    
            }

        }


        if (copChiller != '') {

            
            if (parseFloat(copChiller.replaceAll(',','.')) == 0) {

                window.toastr.error('<b>COP</b> não pode ser igual a zero!')
                return false
    
            }

        }

        

        

        if (tipoChiller == '') {

            window.toastr.error('<b>Tipo de Chiller</b> não pode ficar em branco!')
            return false;

        }


        if (cag == '') {

            window.toastr.error('<b>CAG</b> não pode ficar em branco!')
            return false;

        }

        if (rotinaManutencaoChiller == '') {

            window.toastr.error('<b>Rotina de Manutenção</b> não pode ficar em branco!')
            return false;

        }



        if (funcionamentoHorasDiaChiller == '') {


            window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoHorasDiaChiller) > 24) {

                window.toastr.error('<b>Funcionamento [h/dia]</b> não pode ser maior que 24!')
                return false

            }


        }


        if (funcionamentoDiasSemanaChiller == '') {


            window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoDiasSemanaChiller) > 7) {

                window.toastr.error('<b>Funcionamento [dias/semana]</b> não pode ser maior que 7!')
                return false

            }


        }


        if (funcionamentoSemanasAnoChiller == '') {


            window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ficar em branco!')
            return false

        } else {

            
            if (parseInt(funcionamentoSemanasAnoChiller) > 52) {

                window.toastr.error('<b>Funcionamento [semanas/ano]</b> não pode ser maior que 52!')
                return false

            }


        }

        if (entradaOperacaoChiller != '') {


            if (entradaOperacaoChiller.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Entrada em Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = entradaOperacaoChiller.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Entrada em Operação</b>!')
                    return false
    
                }

                if (anoFabricacaoChiller != '' && x_array[1] != '') {

                    var anoFabricacaoChiller_r = parseInt(anoFabricacaoChiller)
                    var anoEntradaOperacaoChiller = parseInt(x_array[1])

                    var dataEntradaChillerTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')

                    if (anoEntradaOperacaoChiller < anoFabricacaoChiller_r) {


                        window.toastr.error('O <b>Ano de entrada em operação</b> não pode ser anterior que o <b>ano de fabricação</b>!')
                        return false


                    }

                }


            }
            

        }


        if (saidaOperacaoChiller != '') {


            if (saidaOperacaoChiller.indexOf('/') == -1) {

                window.toastr.error('Por favor, preencha o campo <b>Saída de Operação</b> no formato correto: MM/AAAA!')
                return false

            } else {


                var x_array = saidaOperacaoChiller.split('/')

                //console.log(x_array, 'aqui..')

                if (parseInt(x_array[0]) > 12) {

                    window.toastr.error('Consta um mês inválido no campo <b>Saída de Operação</b>!')
                    return false
    
                }


                if (anoEntradaOperacaoChiller != '' && x_array[1] != '') {
                
                    var anoSaidaOperacaoChiller = parseInt(x_array[1])

                    var dataSaidaChillerTemp = moment(`${x_array[1]}-${x_array[0]}-01`).format('YYYY-MM-DD')
                        //console.log(dataEntradaTemp, dataSaidaTemp)

                        //console.log('aqui..')

                    if (dataSaidaChillerTemp < dataEntradaChillerTemp) {

                        window.toastr.error('Data de saída de operação precisa ser posterior a data de entrada em operação!')
                        return false

                    }



                }


            }
            

        }




        var dataPost = {

            ano: ano,
            adesao_institucional_id: adesao_institucional_id,
            energia_id: energia_id,
            marcaChiller: marcaChiller,
            anoFabricacaoChiller: anoFabricacaoChiller,
            quantidadeChiller: quantidadeChiller,
            capacidadeTermicaChiller: capacidadeTermicaChiller,
            potenciaEletricaChiller: potenciaEletricaChiller,
            copChiller: copChiller,
            fluidoRefrigeranteChiller: fluidoRefrigeranteChiller,
            tipoChiller: tipoChiller,
            condensacao: condensacao,
            queima: queima,
            cag: cag,
            rotinaManutencaoChiller: rotinaManutencaoChiller,
            funcionamentoHorasDiaChiller: funcionamentoHorasDiaChiller,
            funcionamentoDiasSemanaChiller: funcionamentoDiasSemanaChiller,
            funcionamentoSemanasAnoChiller: funcionamentoSemanasAnoChiller,
            entradaOperacaoChiller: entradaOperacaoChiller,
            saidaOperacaoChiller: saidaOperacaoChiller,
            modeloChiller: modeloChiller,

        }

        //console.log(dataPost)


        window.$.confirm({
			//icon: 'fa fa-question',
            theme: 'material',
            closeIcon: true,
            animation: 'scale',
            type: 'green',
		    title: 'Confirmação',
		    content: 'Confirma os dados?',
		    buttons: {
		        Sim: function () {


                    if (energiaHvacExpansaoIndireta_id) {

                        //console.log('put')

                        api.put(`energiaHvacExpansaoIndireta/${energiaHvacExpansaoIndireta_id}`, dataPost).then((result) => {
    
                            //setShow2(false)
                            //consultaHvacExpansaoIndireta()
                            //window.toastr.success('Registro salvo com sucesso!')

                            window.$('#modalHVACIndireta').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })


                    } else {

                        api.post('energiaHvacExpansaoIndireta', dataPost).then((result) => {

                           
                            //setShow2(false)
                            //consultaHvacExpansaoIndireta()
                            //window.toastr.success('Registro salvo com sucesso!')


                            window.$('#modalHVACIndireta').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')

    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })

                    }

                    
                    
                    

                },
		        Cancelar: function () {
		            //$.alert('Canceled!');
		        }

            },

        });


    }



    function apagaExpansaoIndireta() {

        if (energiaHvacExpansaoIndireta_id) {

            window.$.confirm({
                //icon: 'fa fa-question',
                theme: 'material',
                closeIcon: true,
                animation: 'scale',
                type: 'red',
                title: 'Confirmação',
                content: 'Confirma apagar?',
                buttons: {
                    Sim: function () {
    
                        
                        api.delete(`energiaHvacExpansaoIndireta/${energiaHvacExpansaoIndireta_id}`).then((result) => {
    
                            //console.log(result.data)
                            //setShow2(false)
                            //consultaHvacExpansaoIndireta()

                            window.$('#modalHVACIndireta').modal('hide')
                            setAtualizacaoGestao(moment().format('YYYY-MM-DD HH:mm:ss'))
                            window.toastr.sucess('Registro apagado com sucesso')
    
                        }).catch((err) => {
    
                            console.log(err.response)
    
                        })
    
                    },
                    Cancelar: function () {
                        //$.alert('Canceled!');
                    }
    
                },
    
            });
    


        }

    }




    const handleChange = (e) => {
        e.preventDefault();
    }


    useEffect(() => {

        carregaAnos()
        carregaMarcaChiller()
        carregaHvacDetIndireta()
        consultaFluidoRefrigerante()
        

    }, [energiaHvacExpansaoIndireta_id])

    return (

        <div>

                <div className="modal fade" id="modalHVACIndireta" tabindex="-1" role="dialog" aria-hidden="true" data-focus="true" >
                    <div className="modal-dialog modal-lg" role="document" >
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                <h1 className="modal-title">HVAC - Sistema Central - Expansão Indireta (CAG-Chiller)</h1>
                            </div>
                            <div className="modal-body">


                                <div className="row">

                                <div className="col-md-12" >
                                    <b>Dados básicos</b>
                                    <br/><br/>
                            </div>
                                
                                
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Marca do Chiller *</label>
                                        <select class="form-control" value={marcaChiller} onChange={event => setMarcaChiller(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            <option value="Não informado">Não informado</option>
                                            {resultadoMarcaChiller}
                                            
                                        </select>
                                            
                                    </div>
                                </div>
                                <div className="col-md-6" >
                                    <div class="form-group" >
                                    
                                        <label className="control-label">Modelo do Chiller</label>
                                        <input type="text" className="form-control" value={modeloChiller} onChange={event => setModeloChiller(event.target.value)} />
                                        
                                            
                                    </div>
                                </div>

                                <div className="col-md-3" >
                                    <div class="form-group" >
                                        <br/>
                                        <label className="control-label">Ano de Fabricação *</label>
                                        <select class="form-control" input="text" value={anoFabricacaoChiller} onChange={event => setAnoFabricacaoChiller(event.target.value)}>
                                            <option value="">[Selecione]</option>
                                            {listaAnos}
                                            <option value="0">Não informado</option>
                                        </select>
                                        
                                        
                                            
                                    </div>
                                </div>
                                
                                <div className="col-md-3" >
                                    <div class="form-group" >
                                    <br/>
                                        <label className="control-label">Quantidade *</label>
                                        <input class="form-control" input="text" value={quantidadeChiller} onChange={event => setQuantidadeChiller(event.target.value)}
                                        onCut={handleChange}
                                        onCopy={handleChange}
                                        onPaste={handleChange}
                                        onKeyPress={(event) => {
                                            if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                            }
                                        }} 
                                        />
                                            
                                    </div>
                                </div>


                                <div className="col-md-12" >
                                    <br/><br/>
                                    <b>Dados Técnicos</b>
                                    <br/><br/>
                                </div>
                                    
                                    
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Capacidade Térmica * [TR]</label>
                                            <input class="form-control" input="text" value={capacidadeTermicaChiller} onChange={event => setCapacidadeTermicaChiller(event.target.value)} onBlur={() => avisoCopChiller()}
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                        
                                            <label className="control-label">Potência Elétrica * [kW]</label>
                                            <input class="form-control" input="text" value={potenciaEletricaChiller} onChange={event => setPotenciaEletricaChiller(event.target.value)} onBlur={() => avisoCopChiller()}
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">COP [W/W]</label>
                                            <input class="form-control" input="text" value={copChiller} onChange={event => setCopChiller(event.target.value)} 
                                            onKeyPress={(e)=>onlyNumberWithTwoDecimal(e)}
                                            onCut={handleChange}
                                            onCopy={handleChange}
                                            onPaste={handleChange}
                                            />
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-6" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Fluído Refrigerante</label>
                                            <select class="form-control" value={fluidoRefrigeranteChiller} onChange={event => setFluidoRefrigeranteChiller(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                {resultadoFluidoRefrigerante}
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Tipo de Chiller *</label>
                                            <select class="form-control"  value={tipoChiller} onChange={event => setTipoChiller(event.target.value)} >
                                                <option value="">[Selecione]</option>
                                                <option value="Elétrico">Elétrico</option>
                                                <option value="Absorção a Gás">Absorção a Gás</option>

                                                
                                            </select>
                                                
                                        </div>
                                    </div>

                                    <div className="col-md-4" >
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Condensação *</label>
                                            <select class="form-control"  value={condensacao} onChange={event => setCondensacao(event.target.value)}>
                                                <option value="">[Selecione]</option>
                                                <option value="Água">Água</option>
                                                <option value="Ar">Ar</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>
                                    <div className="col-md-4" style={{ display: tipoChiller == 'Absorção a Gás' ? 'table-row' : 'none'}}>
                                        <div class="form-group" >
                                            <br/>
                                            <label className="control-label">Queima</label>
                                            <select class="form-control"  value={queima} onChange={event => setQueima(event.target.value)} onBlur={() => avisoQueima()}>

                                                <option value="">[Selecione]</option>
                                                <option value="Direta">Direta</option>
                                                <option value="Indireta">Indireta</option>
                                                
                                            </select>
                                                
                                        </div>
                                    </div>


                                    


                                    <div className="col-md-12" >
                                        <br/><br/>
                                        <b>Dados Operacionais</b>
                                        <br/><br/>
                                    </div>
                                        
                                        
                                        <div className="col-md-8" >
                                            <div class="form-group" >
                                            

                                            <label className="control-label">

                                                <span class="wrapper2">
                                                CAG *
                                                    <div class="tooltip">
                                                    Chillers da mesma CAG devem receber a mesma numeração.



                                                    </div>
                                                </span>

                                            </label>

                                                
                                                <select class="form-control"  value={cag} onChange={event => setCag(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="CAG 01">CAG 01</option>
                                                    <option value="CAG 02">CAG 02</option>
                                                    <option value="CAG 03">CAG 03</option>
                                                    <option value="CAG 04">CAG 04</option>
                                                    <option value="CAG 05">CAG 05</option>
                                                    <option value="CAG 06">CAG 06</option>
                                                    <option value="CAG 07">CAG 07</option>
                                                    <option value="CAG 08">CAG 08</option>
                                                    <option value="CAG 09">CAG 09</option>
                                                    
                                                </select>
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                            
                                                <label className="control-label">Rotina de Manutenção *</label>
                                                <select class="form-control" value={rotinaManutencaoChiller} onChange={event => setRotinaManutencaoChiller(event.target.value)}>
                                                    <option value="">[Selecione]</option>
                                                    <option value="Períodica Semanal">Periódica Semanal</option>
                                                    <option value="Períodica Mensal">Periódica Mensal</option>
                                                    <option value="Períodica Anual">Periódica Anual</option>
                                                    <option value="Corretiva (mediante falha)">Corretiva (mediante falha)</option>
                                                    
                                                </select>
                                                    
                                            </div>
                                        </div>

                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [h/dia] *</label>
                                                <input class="form-control" input="text" value={funcionamentoHorasDiaChiller} onChange={event => setFuncionamentoHorasDiaChiller(event.target.value)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [dias/semana] *</label>
                                                <input class="form-control" input="text"  value={funcionamentoDiasSemanaChiller} onChange={event => setFuncionamentoDiasSemanaChiller(event.target.value)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-4" >
                                            <div class="form-group" >
                                                <br/>
                                                <label className="control-label">Funcionamento [semanas/ano] *</label>
                                                <input class="form-control" input="text"  value={funcionamentoSemanasAnoChiller} onChange={event => setFuncionamentoSemanasAnoChiller(event.target.value)}
                                                onCut={handleChange}
                                                onCopy={handleChange}
                                                onPaste={handleChange}
                                                onKeyPress={(event) => {
                                                    if (!/[0-9]/.test(event.key)) {
                                                    event.preventDefault();
                                                    }
                                                }} 
                                                />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>

                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                        Entrada em operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        insira a data (mês e ano) quando o equipamento entrou em operação na unidade.


                                                        </div>
                                                    </span>

                                                </label>

                                                <InputMask mask="99/9999" class="form-control"  value={entradaOperacaoChiller} onChange={event => setEntradaOperacaoChiller(event.target.value)}  />
                                                    
                                            </div>
                                        </div>
                                        <div className="col-md-6" >
                                            <div class="form-group" >
                                                <br/>

                                                <label className="control-label">

                                                    <span class="wrapper2">
                                                    Saída de operação (Mês/Ano)
                                                        <div class="tooltip">
                                                        Insira a data (mês e ano) quando o equipamento saiu de operação na unidade. Deixar em branco caso ainda esteja em operação.



                                                        </div>
                                                    </span>

                                                </label>

                                                
                                                <InputMask mask="99/9999" class="form-control"  value={saidaOperacaoChiller} onChange={event => setSaidaOperacaoChiller(event.target.value)} />
                                                    
                                            </div>
                                        </div>

                                

                                

                                </div>

                            </div>
                            <div className="modal-footer">
                            
                                <button type="button" className="btn btn-danger" onClick={() => apagaExpansaoIndireta()} style={{ display: energiaHvacExpansaoIndireta_id ? 'table-row' : 'none'}} >Apagar</button>
                                <button type="button" className="btn btn-success" onClick={() => salvaExpansaoIndireta()}>Salvar</button>
                                <button type="button" className="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                
                            </div>
                        </div>
                    </div>
                </div>


        </div>

    )

}


export default Modal